import { render, staticRenderFns } from "./Calificationticket.vue?vue&type=template&id=11a50f73"
import script from "./Calification.js?vue&type=script&lang=js&external"
export * from "./Calification.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports